import React from 'react';
import { Clock } from 'lucide-react';

interface Props {
    message: string;
    expired_at: string;
}

export default function Expired({ message, expired_at }: Props) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 flex items-center justify-center p-6">
            <div className="text-center">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 dark:bg-yellow-900/20 rounded-full mb-6">
                    <Clock className="h-10 w-10 text-yellow-600 dark:text-yellow-400" />
                </div>
                <h1 className="text-3xl font-bold mb-2">Link Expired</h1>
                <p className="text-muted-foreground max-w-md mx-auto mb-4">
                    {message}
                </p>
                <p className="text-sm text-muted-foreground">
                    Expired on {new Date(expired_at).toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}